<template>
  <div class="">
    <!-- 音视频 -->
    <div v-if="type === 3 || isFolderPlay" class="video-wrap">
      <img
        v-if="!isPlay"
        width="800"
        height="450"
        :src="require('@/assets/productService/video-banner.jpg')"
        alt=""
      />
      <video
        v-else
        autoplay="autoplay"
        controls
        controlsList="nodownload noremoteplayback"
        style="width: 800px; height: 450px"
        :src="videoUrl"
      ></video>
    </div>

    <!-- 图形信息 -->
    <div v-if="type === 5" class="wan-drawer-content-item-wrap img-wrap">
      <div
        class="img-item"
        v-for="(item, index) in [drawerDetails]"
        :key="index"
      >
        <div class="img-left">{{ item.resName }}</div>

        <div class="right">
          <span ref="copy-url" @click="$utils.copyText(drawerDetails.fileUrl)"
            >复制地址</span
          >
          | <span @click="$utils.openFile(drawerDetails.fileUrl)">打开</span> |
          <span @click="$utils.downLoadFile(drawerDetails)">下载</span>
        </div>
      </div>
    </div>

    <!-- 文件信息 -->
    <div class="wan-drawer-content-item-wrap file-msg-wrap">
      <div class="file-msg">
        <img
          class="file-img"
          :src="
            drawerDetails.coverUrl
              ? drawerDetails.coverUrl
              : require('@/assets/empty.png')
          "
          alt=""
        />

        <div>
          <p
            style="
              width: 540px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            "
          >
            {{
              drawerDetails.resName
                ? drawerDetails.resName
                : drawerDetails.caseName
            }}
          </p>

          <!-- 集合型档夹 -->
          <p v-if="drawerParams.type === 1">
            创建：{{ drawerDetails.founder }} {{ drawerDetails.createTime }}
          </p>
          <p v-if="drawerParams.type === 1">
            内容：{{ drawerDetails.resourceNum }}
          </p>

          <!-- 项目型档夹 -->
          <p v-if="drawerParams.type === 2">
            周期：{{ drawerDetails.founder }} {{ drawerDetails.createTime }}
          </p>
          <p v-if="drawerParams.type === 2">PM：{{ drawerDetails.pm }}</p>

          <!-- 文件 -->
          <p v-if="drawerDetails.fileType">
            日期：{{ drawerDetails.createTime }}
          </p>
          <p v-if="drawerDetails.fileType">上传：{{ drawerDetails.founder }}</p>
        </div>
      </div>
    </div>

    <!-- 分类 -->
    <div
      v-if="classifyList.length > 0"
      class="wan-drawer-content-item-wrap classify-wrap"
    >
      <div class="wan-drawer-content-title">分类</div>
      <div
        class="wan-drawer-content classify-item"
        v-for="(item, index) in classifyList"
        :key="index"
      >
        <div class="classify-item__title">{{ item.name }}：</div>
        <div
          class="classify-item__msg"
          v-for="(item2, index2) in item.subList"
          :key="item2.id"
        >
          {{ item2.name }}
          {{ item.subList.length - 1 === index2 ? "" : "，" }}
        </div>
      </div>
    </div>

    <!-- 项目成员 -->
    <div
      v-if="
        type === 2 &&
        drawerDetails.memberList &&
        drawerDetails.memberList.length > 0
      "
      class="wan-drawer-content-item-wrap"
    >
      <div class="wan-drawer-content-title" style="margin-bottom: 0">
        <span>项目成员</span>
        <span class="msg">{{ drawerDetails.memberList.length }}名</span>
      </div>
      <div class="project-members-wrap">
        <div
          class="project-members"
          v-for="(item, index) in drawerDetails.memberList"
          :key="index"
        >
          <img class="project-members-avator" :src="item.headerUrl" alt="" />
          <div class="name-pm">{{ item.name }}</div>
          <div class="">{{ item.specialtyName }}</div>
        </div>
      </div>
    </div>

    <!-- 播放清单 -->
    <div
      v-if="
        (type === 1 || type === 2) &&
        drawerDetails.resourceList &&
        drawerDetails.resourceList.length > 0
      "
      class="wan-drawer-content-item-wrap file-msg-wrap play-list-wrap"
    >
      <div class="wan-drawer-content-title">
        <span>播放清单</span>
        <span class="msg">{{ drawerDetails.resourceList.length }}个</span>
      </div>
      <div
        class="file-msg"
        v-for="(item, index) in drawerDetails.resourceList"
        :key="index"
        @click="playList(item, index)"
      >
        <img
          class="file-img"
          :src="item.coverUrl ? item.coverUrl : require('@/assets/empty.png')"
          alt=""
        />

        <div style="color: #000000">
          <p>
            <span
              :style="{
                color: activePlayIndex === index ? '#1B55F4' : '#000000',
                fontWeight: activePlayIndex === index ? 'bold' : 'normal',
              }"
            >
              <!--{{ item.fileTypeName }} | -->{{ item.resName }}
              {{ activePlayIndex === index ? " 正在播放..." : "" }}
            </span>
          </p>
          <!--<p>上传：{{ item.founder }} {{ item.createTime }}</p>-->
          <p>
            <span style="color:#1b55f4;" @click.stop="$utils.copyText(item.resUrl)">复制{{ item.fileTypeName }}地址</span>
            <span style="margin: 0 5px;">|</span>
            <span style="color:#1b55f4;" @click.stop="$utils.downLoadFile(item)">下载</span>
          </p>
        </div>
      </div>
    </div>

    <!-- 关联合作 -->
<!--    <div v-if="type !== 1 && type !== 2" class="wan-drawer-content-item-wrap">
      <div class="wan-drawer-content-title">关联合作</div>
      <div class="wan-drawer-content">{{ drawerDetails.resAscrName }}</div>
    </div>-->

    <!-- 资源介绍 -->
    <div v-if="type !== 1 && type !== 2" class="wan-drawer-content-item-wrap">
      <div class="wan-drawer-content-title">资源介绍</div>
      <div class="wan-drawer-content" v-html="drawerDetails.remark"></div>
    </div>

    <!-- 手机预览 -->
    <div v-if="drawerParams.type !== 7" class="wan-drawer-content-item-wrap">
      <div class="wan-drawer-content-title">手机预览</div>
      <div class="wan-drawer-content">
        <p>微信扫描如下二维码，可直接手机查看并可执行分享等操作</p>
        <div class="qr-code">
          <img
            style="width: 200px; height: 200px; margin-top: 20px"
            :src="`data:image/png;base64,${drawerDetails.qrCode}`"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import clipboard from "clipboard-all";

export default {
  name: "wan-resources-details",

  props: {
    // 弹窗是否打开
    drawerVisible: {
      type: Boolean,
      default: false,
    },

    // 弹窗参数
    drawerParams: {
      type: Object,
      default: () => ({
        type: 1,
      }),
    },

    // 详情数据
    drawerDetails: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      isPlay: false,
      isFolderPlay: false,
      videoUrl: "",
      activePlayIndex: null,
    };
  },

  computed: {
    type() {
      // let type = 1
      //
      // switch (this.drawerParams.type) {
      //   case 1:
      //     type = 1
      // }
      /**
       * type
       * 1 集合型档夹
       * 2 项目档夹
       * 3 视频和音频
       * 4 文档
       * 5 图片
       * 6 H5
       * 7 其他
       * */
      return this.drawerParams.type;
    },

    // 分类数据
    classifyList() {
      let resClass = this.drawerDetails.resClass
        ? JSON.parse(this.drawerDetails.resClass)
        : this.drawerDetails.sysCateList
        ? JSON.parse(this.drawerDetails.sysCateList)
        : [];
      let customContentCate = this.drawerDetails.customContentCate
        ? JSON.parse(this.drawerDetails.customContentCate)
        : [];
      return [...resClass, ...customContentCate];
    },
  },

  watch: {
    drawerVisible(newValue) {
      if (!newValue) {
        this.isPlay = false;
      }
    },
  },

  mounted() {
    this.$bus.on("closeH5", () => {
      this.activePlayIndex = null;
    });
  },

  methods: {
    playVideo(url) {
      this.videoUrl = url;
      this.isPlay = true;
    },
    playList(item, index) {
      if (this.activePlayIndex === index) return;
      console.log(item, index);
      switch (Number(item.fileType)) {
        // h5
        case 122:
          this.activePlayIndex = index;
          this.$bus.emit("openH5", {
            ...item,
            url: item.resUrl,
            title: item.resName,
          });
          break;
        // 视频
        case 85:
        case 119:
          this.activePlayIndex = index;
          this.$bus.emit("openH5", {
            ...item,
            url: item.fileUrl,
            title: item.resName,
          });
          break;
      }
    },
  },
};
</script>

<style scoped></style>
